import type {BioIconProps} from './common-types'

function Icon({...attributes}: BioIconProps) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <circle cx="10" cy="10" r="9.5" fill="#F0FDF4" stroke="#15803D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2715 6.4696C15.4121 6.61025 15.4911 6.80099 15.4911 6.99987C15.4911 7.19875 15.4121 7.38949 15.2715 7.53014L9.27122 13.5304C9.13056 13.671 8.93983 13.75 8.74094 13.75C8.54206 13.75 8.35132 13.671 8.21067 13.5304L5.21054 10.5303C5.07392 10.3888 4.99832 10.1994 5.00003 10.0027C5.00174 9.80604 5.08062 9.61793 5.21968 9.47886C5.35874 9.3398 5.54686 9.26092 5.74351 9.25921C5.94017 9.2575 6.12963 9.3331 6.27109 9.46973L8.74094 11.9396L14.2109 6.4696C14.3516 6.32899 14.5423 6.25 14.7412 6.25C14.9401 6.25 15.1308 6.32899 15.2715 6.4696Z"
        fill="#15803D"
      />
    </svg>
  )
}

export const IconKeySpec = Icon
